import { Box, Tab, Tabs, Typography } from "@mui/material";
import { t } from "i18next";
import React from "react";

interface TabConfig {
  value: number;
  labelKey: string;
  icon: React.ReactElement;
  component: React.ReactNode;
  hasAccess: boolean;
}

interface SidebarProps {
  value: number;
  handleChange: (_: React.SyntheticEvent, newValue: number) => void;
  tabs: TabConfig[];
}

const Sidebar = ({ value, handleChange, tabs }: SidebarProps) => {
  return (
    <Box
      sx={{
        height: "100%",
        backgroundColor: "#fefffe",
        borderRight: "1px solid #ddd",
        transition: "width 0.3s ease",
        width: "100px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        paddingTop: 2,
        "& .tabLabel": {
          maxHeight: 0,
          opacity: 0,
          overflow: "hidden",
          transition: "all 0.2s ease, opacity 0.3s ease, margin 0.3s ease"
        }
      }}
    >
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="chatbot-tabs"
        sx={{
          width: "100%",
          "& .MuiTabs-indicator": {
            display: "none" // Delete the border right representing active tab
          }
        }}
      >
        {tabs.map((tab, index) => (
          tab.hasAccess && (
            <Tab
              key={index}
              icon={tab.icon}
              value={tab.value}
              label={
                <Typography fontSize="12px">
                  {t(tab.labelKey)}
                </Typography>
              }
              sx={{
                minHeight: "auto",
                textTransform: "capitalize",
                transition: "background-color 0.3s ease, color 0.3s ease",
                "&:hover": {
                  bgcolor: "primary.main",
                  color: "#fefffe",
                  "& .MuiSvgIcon-root": { color: "#fefffe" },
                  "& .tabLabel": { color: "#fefffe" }
                }
              }}
            />
          )
        ))}
      </Tabs>
    </Box>
  );
};

export default Sidebar; 